import React from 'react'
import { useLazyQuery, useQuery } from '@apollo/client'
import { Invoices, InvoicesVariables, TypeFilter } from '../../types'
import { INVOICES } from './operations'

interface Filters {
  invoicedBetween?: Array<string | null>
  typeFilter?: TypeFilter
}

interface Props {
  filter?: Filters
  page?: number
  pageLength?: number
  skip?: boolean
}

interface LazyProps {
  onCompleted?: (data: Invoices) => void
}

const PAGE_LENGTH = 10

export const useInvoices = ({
  filter,
  page = 1,
  pageLength = PAGE_LENGTH,
  skip = false,
}: Props = {}) => {
  const { invoicedBetween, typeFilter } = filter || {}
  const queryVariables = React.useMemo<InvoicesVariables>(
    () => ({
      filterData: {
        invoicedBetween,
        typeFilter,
      },
      pagination: {
        from: pageLength * (page - 1),
        length: pageLength,
      },
    }),
    [invoicedBetween, typeFilter]
  )
  const invoices = useQuery<Invoices, InvoicesVariables>(INVOICES, {
    variables: queryVariables,
    skip,
  })

  return invoices
}

export const useInvoicesLazy = ({ onCompleted }: LazyProps) =>
  useLazyQuery<Invoices, InvoicesVariables>(INVOICES, {
    onCompleted,
  })
